
const isStorageAvailable = () => {
    try {
        const test = '__storage_test__';
        localStorage.setItem(test, test);
        localStorage.removeItem(test);
        return true;
    } catch (e) {
        return false;
    }
};

const memoryStorage: Record<string, string> = {};

export const SafeStorage = {
    getItem: (key: string): string | null => {
        try {
            if (isStorageAvailable()) {
                return localStorage.getItem(key);
            }
            return memoryStorage[key] || null;
        } catch (error) {
            console.warn(`SafeStorage.getItem failed for key "${key}":`, error);
            return memoryStorage[key] || null;
        }
    },

    setItem: (key: string, value: string): void => {
        try {
            if (isStorageAvailable()) {
                localStorage.setItem(key, value);
            } else {
                memoryStorage[key] = value;
            }
        } catch (error) {
            console.warn(`SafeStorage.setItem failed for key "${key}":`, error);
            memoryStorage[key] = value;
        }
    },

    removeItem: (key: string): void => {
        try {
            if (isStorageAvailable()) {
                localStorage.removeItem(key);
            }
            delete memoryStorage[key];
        } catch (error) {
            console.warn(`SafeStorage.removeItem failed for key "${key}":`, error);
            delete memoryStorage[key];
        }
    },

    clear: (): void => {
        try {
            if (isStorageAvailable()) {
                localStorage.clear();
            }
            Object.keys(memoryStorage).forEach(key => delete memoryStorage[key]);
        } catch (error) {
            console.warn('SafeStorage.clear failed:', error);
            Object.keys(memoryStorage).forEach(key => delete memoryStorage[key]);
        }
    }
};
